import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';

import { ReactComponent as LinkSvg } from '@frontend/icons/external-link-2.svg';
import { links } from '../../utils/links';

export default function RefundComplete(): JSX.Element {
  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="success">
            <WidgetHeaderContent title="Refund complete" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <WidgetStatus
              emoji="💵"
              title="Refund complete"
              description={
                <>
                  Your refund has already been processed. <br /> If you’re
                  having any issues our team is here for you.
                </>
              }
            />
          }
          footer={
            <Button
              as="a"
              size="large"
              href={links.support.learn_refunds}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              rightIcon={<Icon component={<LinkSvg />} />}
            >
              Learn about refunds
            </Button>
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
}
